import React from "react";
import { connect } from "react-redux";
//
import Screen from "./ConnectedScreen";

const ThankyouScreen = ({ isActive, isSms, isEmail, model, hideModal }) => (
  <Screen
    title="Thank you"
    isActive
    onBack={false}
    nextLabel="Close"
    onNext={hideModal}
  >
    {isSms && (
      <p>A confirmation SMS will be sent to you within 5-10 minutes.</p>
    )}
    {isEmail && (
      <div>
        <p>A confirmation email will be sent to you within 5-10 minutes.</p>
        <p>Please do check your spam box as well.</p>
      </div>
    )}
    <p>
      We hope that you have a great time with{" "}
      <span className="u-brand">{model.name}</span>.
    </p>
    <p>The Smooci Team</p>
  </Screen>
);

// @connect
import { bindActionCreators as bindActions } from "redux";
//
import { hideModal } from "../modules/modal";

const state = ({ booking }) => ({
  isEmail: true,
  isSms: false,
  // isEmail: booking.otpType === "email",
  // isSms: booking.otpType === "sms",
});

const actions = (dispatch) => bindActions({ hideModal: hideModal }, dispatch);

export default connect(
  state,
  actions
)(ThankyouScreen);
